import $api from "../http";
import { AxiosResponse } from "axios";
import { AuthResponse } from "../models/response/AuthResponse";
import { IUser } from "../models/IUser";

export default class AuthService {

    static async login(email: string, password: string): Promise<AxiosResponse<AuthResponse>> {
        return $api.post<AuthResponse>('auth/jwt/create/', {email, password});
    };

    static async registration(data: object): Promise<AxiosResponse<IUser>> {
        return $api.post<IUser>('auth/users/', {...data});
    };

    static async registrationMail(email: object): Promise<AxiosResponse<IUser>> {
        return $api.post<IUser>('api/reg_mail/', email);
    };

    static activate(uid: any, token: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('auth/users/activation/', {uid, token})
    };

    static async passReset(data: object): Promise<AxiosResponse<any>> {
        return $api.post<any>('auth/users/reset_password/', data);
    };

    static async passwordReset(data: object): Promise<AxiosResponse<any>> {
        return $api.post<any>('auth/users/reset_password_confirm/', data);
    };

    static async setNewPass(data: object): Promise<AxiosResponse<any>> {
        return $api.post<any>('auth/users/set_password/', data);
    };

};